module.exports = __webpack_public_path__ + "static/media/enable-downloads-example.60fa25f6.svg";